export class InsolesPatientSummaryModel {
    id: number;
    fullName: string;
}
